module.exports = __webpack_public_path__ + "basic1.png?d5e4562339033929516994cfcaa4e4de";